const ScheduleFunctions = {
    Unknown: 0,
    CallServiceBus: 1
};

export default ScheduleFunctions;
